import NotificationList from "./NotificationList";

class UserNotificationList extends NotificationList {
    static permissions = ['user-notifications'];
    url = '/notifications';
    title = 'Twoje powiadomienia';
}

export default UserNotificationList;
